import React, { useState, useCallback } from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import MultipleFileUploadSection from '../../VendorInvoiceManagement/components/multiple_file_upload_section.component';
import { uploadAdminMissingDocuments } from '../functions/upload_missing_documents_admin.function';
import { notify } from '../../../common/functions/react-toastify.function';

const AddMissingDocumentsAdminSection = ({ invoiceNumber, onSaved, disabled }) => {
  const [files, setFiles] = useState([]);
  const [saving, setSaving] = useState(false);

  const handleSave = useCallback(async () => {
    if (!invoiceNumber || !files.length || saving || disabled) {
      return;
    }
    setSaving(true);
    try {
      const response = await uploadAdminMissingDocuments(invoiceNumber, files);
      const invoice = response?.invoice;
      notify('success', 'Documents saved');
      setFiles([]);
      if (typeof onSaved === 'function' && invoice) {
        onSaved(invoice);
      }
    } catch {
      // handleApiError already ran
    } finally {
      setSaving(false);
    }
  }, [invoiceNumber, files, saving, disabled, onSaved]);

  return (
    <Box sx={{ mt: 2 }}>
      <MultipleFileUploadSection
        description="Add missing documents"
        downloadLinkText="PDF, Excel, CSV, MSG, and KMZ files only"
        files={files}
        onFilesChange={setFiles}
      />
      <Button
        variant="contained"
        disabled={!files.length || saving || disabled || !invoiceNumber}
        onClick={handleSave}
        sx={{
          mt: 1,
          backgroundColor: '#BD1D23',
          '&:hover': { backgroundColor: '#9a1820' },
        }}
      >
        {saving ? (
          <>
            <CircularProgress size={18} color="inherit" sx={{ mr: 1 }} />
            Saving…
          </>
        ) : (
          'Save documents'
        )}
      </Button>
    </Box>
  );
};

export default AddMissingDocumentsAdminSection;
